import { InputGroupInput } from '@playbooks/ui/components/input-group'
import { InputProps } from '../types'
import InputGroupWrapper from '../../../components/ui/InputGroupeWrapper'

export default function TextInput({ question, onChange, invalid, type = 'text' }: InputProps) {
  return (
    <InputGroupWrapper>
      <InputGroupInput
        id={`question-${question.id}`}
        type={type}
        value={(question.value as string) ?? ''}
        onChange={e => onChange(e.target.value)}
        aria-invalid={invalid}
        required={question.required}
      />
    </InputGroupWrapper>
  )
}
